namespace $ {
	
	export class $mol_rest_port_ws_node extends $mol_rest_port_ws {
		
		prolog!: InstanceType< $node['http']['IncomingMessage'] >
		socket!: InstanceType< $node['stream']['Duplex'] >
		
		@ $mol_mem
		upgrade(): $mol_rest_message_http {
			return $mol_rest_message_http.make({ port: this, input: this.prolog })
		}
		
		origin() {
			return this.upgrade().origin()
		}

		address() {
			return this.upgrade().address()
		}

		@ $mol_action
		send_nil() {
			if( this.socket.writableEnded ) return
			this.socket.write( $mol_websocket_frame.make( 'pong', 0 ).asArray() )
		}
		
		@ $mol_action
		send_bin( data: Uint8Array< ArrayBuffer > ) {
			if( this.socket.writableEnded ) return
			this.socket.write( $mol_websocket_frame.make( 'bin', data.byteLength ).asArray() )
			this.socket.write( data )
		}
		
		@ $mol_action
		send_text( data: string ) {
			if( this.socket.writableEnded ) return
			const bin = $mol_charset_encode( data )
			this.socket.write( $mol_websocket_frame.make( 'txt', bin.byteLength ).asArray() )
			this.socket.write( bin )
		}
		
	}
	
	$.$mol_rest_port_ws = $mol_rest_port_ws_node
	
}
